import api from 'api/instance';

import { Group, PortalUser } from 'types/groups';

import { FetchQueryType, FetchResponse } from 'types/common';
import store from 'store/store';

const URL = `${process.env.REACT_APP_API_URL}`;

export const fetchPaginatedGroups = async (params: FetchQueryType) => {
  const { data } = await api.get<FetchResponse<Group>>(`${URL}/group/list`, {
    params,
  });

  return data;
};

type CreateGroupPayload = {
  washHub: string;
  companyName: string;
  billingContact: string;
  type: string;
};

export const createGroup = async (payload: CreateGroupPayload) => {
  const { data } = await api.post(`${URL}/group/create`, payload);

  return data;
};

type CreatePartnerPortalPayload = {
  washHub: string;
  group: string;
  site: string[];
  name: string;
  logo: string;
  banner: string;
};

export const createPartnerPortal = async (
  payload: CreatePartnerPortalPayload,
) => {
  const { data } = await api.post(
    `${URL}/group/create-partner-portal`,
    payload,
  );

  return data;
};

export const updatePartnerPortal = async ({
  groupId,
  ...payload
}: CreatePartnerPortalPayload & { groupId: string }) => {
  const { data } = await api.patch(
    `${URL}/group/update-partner-portal/${groupId}`,
    payload,
  );

  return data;
};

export const getPortalUsers = async (
  portal: string,
  group: string,
  washHub: string,
) => {
  const { data } = await api.get(`${URL}/partner-portal/list/users`, {
    params: {
      portal,
      group,
      washHub,
    },
  });

  return data?.items as PortalUser[];
};

type AddUserToPortalPayload = {
  portal: string;
  email: string;
};

export const addUserToPortal = async (payload: AddUserToPortalPayload) => {
  const { data } = await api.post(`${URL}/partner-portal/add-user`, payload);

  return data;
};

export const removeUserFromPortal = async ({
  portal,
  userId,
}: {
  portal: string;
  userId: string;
}) => {
  const { data } = await api.delete(
    `${URL}/partner-portal/remove-user/${portal}/${userId}`,
  );

  return data;
};

export const updateGroup = async (payload: any, id: string) => {
  const { data } = await api.patch(`${URL}/group/detail/${id}`, payload);

  return data;
};

export const uploadGroupImage = (
  file: File,
  groupId: string,
  onProgress: (progress: number) => void,
) => {
  return new Promise<string>((resolve, reject) => {
    const formData = new FormData();
    formData.append('image', file);

    const state = store.getState();
    const jwtToken = state?.auth?.currentUser?.tokens?.jwtToken;

    const url = `${URL}/group/upload-group-banner/${groupId}`;

    const xhr = new XMLHttpRequest();

    xhr.open('POST', url, true);
    xhr.setRequestHeader('Authorization', `Bearer ${jwtToken}`);

    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) {
        const progress = (e.loaded / e.total) * 100;

        onProgress(progress);
      }
    };

    xhr.onload = () => {
      if (xhr.status === 201) {
        const response = JSON.parse(xhr.response);
        const fileName = response?.item?.file;

        resolve(fileName);
      } else {
        reject(
          new Error(
            `Request failed. Status: ${xhr.status}. Content: ${
              JSON.parse(xhr.response)?.message
            }`,
          ),
        );
      }
    };

    xhr.send(formData);
  });
};
